export function recordKeys<T extends {}>(record: T): Array<keyof T> {
  return Object.keys(record) as Array<keyof T>;
}
